import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
// import LanguageDetector from 'i18next-browser-languagedetector'
import deTranslation from '../locales/de/translation.json'

const resources = {
  de: {
    translation: { ...deTranslation }
  }
}

i18n.use(initReactI18next).init({
  lng: 'de',
  resources,
  fallbackLng: 'de',
  debug: false,
  keySeparator: false, // dot notation instead of nesting
  defaultNS: 'translation',
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
    prefix: '{',
    suffix: '}'
  }
})

export default i18n
